<template>
  <div
    class="drop-down-block"
    :class="[{ 'hover': hovering }]"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false">
    <div
      class="meta"
      ref="meta">
      <div class="description">
        <slot></slot>
      </div>
    </div>
    <!-- 当存在可见数量时，才展示收缩框 -->
    <div
      class="drop-down-block-control"
      ref="control"
      :class="{ 'is-fixed': fixedControl }"
      @click="handleExpand"
      v-if="visibleNum && visibleNum > 0">
      <transition name="arrow-slide">
        <svg
          class="icon"
          aria-hidden="true"
          :class="[iconClass, { 'hovering': hovering }]">
          <use :xlink:href="iconClass"></use>
        </svg>
      </transition>
      <transition name="text-slide">
        <span v-show="hovering">
          {{ controlText }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script >
import i18n from '@/lang'

export default {
  props: {
    visibleNum: {
      type: Number,
      default: 0
    },
    foldText: {
      type: String,
      default: '收起'
    },
    unfoldText: {
      type: String,
      default: '展开更多'
    }
  },
  data () {
    return {
      hovering: false,
      isExpanded: false,
      fixedControl: false,
      scrollParent: null
    }
  },
  computed: {
    controlText () {
      const { visibleNum, foldText, unfoldText } = this
      return this.isExpanded ? i18n.t(foldText) : i18n.t(unfoldText) + `(${visibleNum}${i18n.t('条')})`
    },
    iconClass () {
      return this.isExpanded ? '#icon-sanjiaoshang' : '#icon-sanjiao'
    },
    codeArea () {
      return this.$el.getElementsByClassName('meta')[0]
    },
    descriptionHeight () {
      return this.$el.getElementsByClassName('description')[0].clientHeight
    }
  },
  watch: {
    isExpanded: {
      handler (val) {
        const height = this.$el.getElementsByClassName('description')[0].clientHeight
        this.codeArea.style.height = `${height + 1}px`
        if (!val) {
          this.fixedControl = false
          this.removeScrollHandler()
          return
        }
        setTimeout(() => {
          this.scrollParent = document.querySelector('.page-component__scroll > .el-scrollbar__wrap')
          this.scrollParent && this.scrollParent.addEventListener('scroll', this.scrollHandler)
          this.scrollHandler()
        }, 200)
      }
      // immediate: true
    }
  },
  mounted () { },
  beforeDestroy () {
    this.removeScrollHandler()
  },
  methods: {
    scrollHandler () {
      const { top, bottom } = this.$refs.meta.getBoundingClientRect()
      this.fixedControl = bottom > document.documentElement.clientHeight &&
        top + 44 <= document.documentElement.clientHeight
      // this.$refs.control.style.left = this.fixedControl ? `${left}px` : '0'
    },
    removeScrollHandler () {
      this.scrollParent && this.scrollParent.removeEventListener('scroll', this.scrollHandler)
    },
    handleExpand () {
      this.$emit('expand', this.isExpanded)
      this.$nextTick(() => {
        this.isExpanded = !this.isExpanded
      })
    }
  }
}
</script>

<style lang="less" scoped>
.drop-down-block {
  position: relative;
  // margin-top: 40px;
  border-radius: 3px;
  transition: 0.2s;
  &.hover {
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
      0 2px 4px 0 rgba(232, 237, 250, 0.5);
  }
  .default-content {
    padding: 20px;
  }
  .meta {
    background-color: transparent;
    overflow: hidden;
    transition: height 0.2s;
    height: 100%;
  }
  .description {
    width: 100%;
    box-sizing: border-box;
    border-radius: 3px;
    line-height: 22px;
    word-break: break-word;
    background-color: @white;
    p {
      margin: 0;
      line-height: 26px;
    }
  }
  .drop-down-block-control {
    border-top: 1px solid #f6f7fc;
    height: 60px;
    box-sizing: border-box;
    background-color: @white;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -2px;
    color: #d3dce6;
    cursor: pointer;
    position: relative;
    z-index: 4;

    &.is-fixed {
      // position: absolute;
      // bottom: 0;
      // width: 100%;
    }
    .icon {
      height: 100%;
      font-size: 12px;
      line-height: 60px;
      transition: 0.3s;
      &.hovering {
        transform: translateX(-40px);
      }
    }
    > span {
      position: absolute;
      transform: translateX(-30px);
      font-size: 14px;
      line-height: 60px;
      transition: 0.3s;
      display: inline-block;
    }
    &:hover {
      color: @blue;
      background-color: @blueLess5;
    }
    & .text-slide-enter,
    & .text-slide-leave-active {
      opacity: 0;
      transform: translateX(10px);
    }

    .control-button {
      line-height: 26px;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      padding-left: 5px;
      padding-right: 25px;
    }
  }
}
</style>
